export default axios => ({
  getBimList: (projectId, payload) => axios.get(`projects/${projectId}/document/bim-model/list`, payload),
  setControlPoints: ({projectId, structureType, structureId, documentId, payload}) => axios.post(`projects/${projectId}/document/bim-model/${structureType}/${structureId}/control-points/${documentId}`, payload),
  getBimModelsList: ({projectId, structureType, structureId, payload}) => axios.get(`projects/${projectId}/document/bim-model/${structureType}/${structureId}`, payload),
  del: payload => axios.get('dirs/job-types/tree', payload),
  projectAttach: (projectId, payload) => axios.post(`projects/${projectId}/autodesk/autodesk-project-attach`, payload)
})
